/* @ngInject */
export default function (APIService, moment, PreferencesService) {
	return {
		...APIService.service('enquiries'),

		defaultObject: () => {
			return {
				serviceUser:  {
					firstName:       '',
					lastName:        '',
					physicalAddress: '',
					region:          '',
					regionComment:   '',
					contactName:     '',
					contactDetails:  '',
					role:            '',
					roleComment:     '',
				},
				funding:      {
					program:        '',
					programComment: '',
					funder:         '',
					funderComment:  '',
					coordinator:    '',
					email:          '',
				},
				service:      {
					type:                     '',
					typeComment:              '',
					hours:                    '',
					days:                     '',
					startDate:                '',
					needs:                    '',
					duration:                 '',
					requirements:             '',
					preferencesAndExclusions: '',
				},
				caseManagers: {
					external: '',
					internal: '',
					comments: '',
				},
				enquiry:      {
					date:                          '',
					method:                        '',
					referredToDanielle:            '',
					referred:                      '',
					referredComment:               '',
					status:                        '',
					reasonNotReferred:             '',
					trainingRequirements:          '',
					expectedTrainingStartDate:     '',
					minimumSupportWorkersRequired: '',
				},
			};
		},

		mapJSONToObject: (json) => {
			return {
				serviceUser:  {
					firstName:       json.serviceUserFirstName,
					lastName:        json.serviceUserLastName,
					physicalAddress: json.serviceUserPhysicalAddress,
					region:          json.serviceUserRegion,
					regionComment:   json.serviceUserRegionComment,
					contactName:     json.serviceUserContactName,
					contactDetails:  json.serviceUserContactDetails,
					role:            json.serviceUserRole,
					roleComment:     json.serviceUserRoleComment,
				},
				funding:      {
					program:        json.fundingProgram,
					programComment: json.fundingProgramComment,
					funder:         json.fundingFunder,
					funderComment:  json.fundingFunderComment,
					coordinator:    json.fundingCoordinator,
					email:          json.fundingEmail,
				},
				service:      {
					type:                     json.serviceType,
					typeComment:              json.serviceTypeComment,
					hours:                    json.serviceHours,
					days:                     json.serviceDays,
					startDate:                json.serviceStartDate,
					needs:                    json.serviceNeeds,
					duration:                 json.serviceDuration,
					requirements:             json.serviceRequirements,
					preferencesAndExclusions: json.servicePreferencesAndExclusions,
				},
				caseManagers: {
					external: json.externalCaseManager,
					internal: (json.internalCaseManager) ? (json.internalCaseManager.id) : (null),
					comments: json.caseManagersComments,
				},
				enquiry:      {
					date:                          moment(json.enquiryDate)
						                               .local()
						                               .format('YYYY-MM-DD'),
					method:                        json.enquiryMethod,
					referredToDanielle:            json.enquiryReferredToDanielle,
					referred:                      json.enquiryReferred,
					referredComment:               json.enquiryReferredComment,
					status:                        json.enquiryStatus,
					reasonNotReferred:             json.enquiryReasonNotReferred,
					trainingRequirements:          json.enquiryTrainingRequirements,
					expectedTrainingStartDate:     json.enquiryExpectedTrainingStartDate,
					minimumSupportWorkersRequired: json.enquiryMinimumSupportWorkersRequired,
				},
			};
		},

		mapObjectToJSON: (object) => {
			return {
				serviceUserFirstName:                 object.serviceUser.firstName,
				serviceUserLastName:                  object.serviceUser.lastName,
				serviceUserPhysicalAddress:           object.serviceUser.physicalAddress,
				serviceUserRegion:                    object.serviceUser.region,
				serviceUserRegionComment:             object.serviceUser.regionComment,
				serviceUserContactName:               object.serviceUser.contactName,
				serviceUserContactDetails:            object.serviceUser.contactDetails,
				serviceUserRole:                      object.serviceUser.role,
				serviceUserRoleComment:               object.serviceUser.roleComment,
				fundingProgram:                       object.funding.program,
				fundingProgramComment:                object.funding.programComment,
				fundingFunder:                        object.funding.funder,
				fundingFunderComment:                 object.funding.funderComment,
				fundingCoordinator:                   object.funding.coordinator,
				fundingEmail:                         object.funding.email,
				serviceType:                          object.service.type,
				serviceTypeComment:                   object.service.typeComment,
				serviceHours:                         object.service.hours,
				serviceDays:                          object.service.days,
				serviceStartDate:                     object.service.startDate,
				serviceNeeds:                         object.service.needs,
				serviceDuration:                      object.service.duration,
				serviceRequirements:                  object.service.requirements,
				servicePreferencesAndExclusions:      object.service.preferencesAndExclusions,
				externalCaseManager:                  object.caseManagers.external,
				internalCaseManager:                  object.caseManagers.internal,
				caseManagersComments:                 object.caseManagers.comments,
				enquiryDate:                          moment(object.enquiry.date)
					                                      .local()
					                                      .format('YYYY-MM-DD'),
				enquiryMethod:                        object.enquiry.method,
				enquiryReferredToDanielle:            object.enquiry.referredToDanielle,
				enquiryReferred:                      object.enquiry.referred,
				enquiryReferredComment:               object.enquiry.referredComment,
				enquiryStatus:                        object.enquiry.status,
				enquiryReasonNotReferred:             object.enquiry.reasonNotReferred,
				enquiryTrainingRequirements:          object.enquiry.trainingRequirements,
				enquiryExpectedTrainingStartDate:     object.enquiry.expectedTrainingStartDate,
				enquiryMinimumSupportWorkersRequired: object.enquiry.minimumSupportWorkersRequired,
			};
		},
	};
};


// WEBPACK FOOTER //
// ./src/js/factories/enquiries/index.js